import React, { useEffect, useRef, useState } from "react";
import "./Body.css";
import softwareEngineeringImg from "./images/software_engineer.png";
import cloudInfrastructureImg from "./images/cloud.png";
import dataAnalyticsImg from "./images/data_analytics.jpg";
import qualityAssuranceImg from "./images/digitalquality.png";
import enterpriseIntegrationImg from "./images/enterprise.png";
import itSecurityImg from "./images/Enterpices_IT_Security.png";
import devGenOpsImg from "./images/devops.png";
import mobileImg from "./images/mobile.png";

import microsoftLogo from "./images/microsoft.png";
import databaseLogo from "./images/databricks.png";
import ampsYoutoLogo from "./images/saleforcs.png";
import hclSoftwareLogo from "./images/hcl.png";
import adobeLogo from "./images/adobe.png";
import awsLogo from "./images/awss.png";
import wosobiLogo from "./images/wasabis.png";
import ingram from "./images/ingram.png";
import mercury from "./images/mercury_gate.png";
import google from "./images/google.png";

import apiEcosystemImage from "./images/apiecosystem.png";
import testingQualityImage from "./images/testingquality.png";
import ecommerceImage from "./images/ecommerce.png";

import blockchainIcon from "./images/blockchain.png";
import salesforceIcon from "./images/salesforcedev.png";
import automationIcon from "./images/automation testing.png";
import metaverseIcon from "./images/metaversedev.png";
import aiIcon from "./images/ai dev.png";
import mobileIcon from "./images/mobility sol.png";
import softwareIcon from "./images/customized software.png";
import gameIcon from "./images/game development.png";
import otherIcon from "./images/other services.png";
import Testimonial from "../Testimonial/Testimonial";

import angular from "./logos/angular.png";
import ai from "./logos/artificial-intelligence.png";
import html from "./logos/html.png";
import css from "./logos/css.png";
import js from "./logos/javascript.png";
import react from "./logos/react_native.png";
import vue from "./logos/tech_vuejs.png";
import vscode from "./logos/tech_vscode.png";
import python from "./logos/tech_python.png";
import gcp from "./logos/tech_gcp.png";
import googleai from "./logos/tech_google.png";
import azure from "./logos/tech_azure.png";
import apacheflink from "./logos/tech_apacheflink.png";
import docker from "./logos/tech_docker.png";
import kubernative from "./logos/tech_kubernative.png";
import grafna from "./logos/tech_grafana.png";
import hadoop from "./logos/tech_hadoop.png";
import kotlin from "./logos/tech_kotlin.png";
import kubeflow from "./logos/tech_kubeflow.png";
import googletpu from "./logos/tech_googletpu.png";
import openai from "./logos/tech_openai.png";
import postsql from "./logos/postgresql.png";
import jupyter from "./logos/tech_jupyter.png";
import anaconda from "./logos/tech_anaconda.png";
import bootstrap from "./logos/bootstrap.png";
import mlflow from "./logos/tech_mlflow.png";
import opencv from "./logos/tech_opencs.png";
import fastai from "./logos/tech_fastai.png";
import flutter from "./logos/flutter.png";
import php from "./logos/php.png";
import solidity from "./logos/Solidity.png";
import keras from "./logos/tech_keras.png";
import tf from "./logos/tech_tensor_flow.png";
import cloudIcon from "./images/cloud body.png";
import securityIcon from "./images/security body.png";
import iotIcon from "./images/iot body.png";
import devopsIcon from "./images/devops body.png";
import designIcon from "./images/design body.png";
import analyticsIcon from "./images/analytics body.png";
import marketingIcon from "./images/marketing body.png";
import ecommerceIcon from "./images/ecommerce body.png";
import arvrIcon from "./images/vr body.png";
import rpaIcon from "./images/robotic body.png";
import enterpriseIcon from "./images/erp body.png";

const industries = [
  { name: "Fintech", icon: "/image/fintech.png", path: "/fintech" },
  { name: "Real Estate", icon: "/image/realestate.png", path: "/real-estate" },
  { name: "Banking", icon: "/image/banking.png", path: "/banking" },
  { name: "Pharma", icon: "/image/pharma.png", path: "/pharma" },
  { name: "Healthcare", icon: "/image/healthcare.png", path: "/health-care" },
  { name: "Welfare", icon: "/image/welfare.png", path: "/welfare" },
  { name: "Art", icon: "/image/art.png", path: "/art" },
  { name: "Insurance", icon: "/image/insurance.png", path: "/insurance" },
  { name: "Government", icon: "/image/government.png", path: "/government" },
  {
    name: "Entertainment",
    icon: "/image/entertainment.png",
    path: "/entertainment",
  },
  { name: "Gaming", icon: "/image/gaming.png", path: "/gaming" },
  { name: "Energy", icon: "/image/energy.png", path: "/energy" },
];

const practices = [
  {
    category: "Technology Practices",
    items: [
      {
        name: "Software Products",
        hasView: true,
        image: softwareEngineeringImg,
        description: "Building robust and scalable software solutions",
        link: "/software-product",
      },
      {
        name: "Cloud & Infrastructure",
        hasView: true,
        image: cloudInfrastructureImg,
        description: "Cloud-native solutions and infrastructure management",
        link: "/cloud-infrastructure",
      },
      {
        name: "Data and Analytics",
        hasView: true,
        image: dataAnalyticsImg,
        description: "Data-driven insights and business intelligence",
        link: "/data-analytics",
      },
      {
        name: "Digital Quality Assurance",
        hasView: true,
        image: qualityAssuranceImg,
        description: "Ensuring quality at every stage of development",
        link: "/digital-quality-assurance",
      },
    ],
  },
  {
    items: [
      {
        name: "Enterprise Integration",
        hasView: true,
        image: enterpriseIntegrationImg,
        description: "Seamless integration across business systems",
        link: "/enterprise-integration",
      },
      {
        name: "Enterprise IT Security",
        hasView: true,
        image: itSecurityImg,
        description: "Comprehensive security solutions for enterprises",
        link: "/enterprise-it-security",
      },
      {
        name: "DevSecOps",
        hasView: true,
        image: devGenOpsImg,
        description: "Next-gen DevOps practices for rapid delivery",
        link: "/dev-sec-ops",
      },
      {
        name: "Mobile",
        hasView: true,
        image: mobileImg,
        description: "Cross-platform mobile application development",
        link: "/mobile",
      },
    ],
  },
];

const partners = [
  { name: "Microsoft", logo: google },
  { name: "Microsoft", logo: microsoftLogo },
  { name: "aws", logo: awsLogo },
  { name: "AMPS/YOUTO", logo: ampsYoutoLogo },
  { name: "database", logo: databaseLogo },
  { name: "HCL SOFTWARE", logo: hclSoftwareLogo },
  { name: "Adobe", logo: adobeLogo },
  { name: "wosobi", logo: wosobiLogo },
  { name: "wosobi", logo: ingram },
  { name: "wosobi", logo: mercury },
];

const blogPosts = [
  {
    id: 1,
    title: "Unleash the Power of Seamless Integrations: API Ecosystem",
    excerpt:
      "In today's data driven world, seamless communication between these systems is crucial for business success...",
    image: apiEcosystemImage,
    alt: "API Ecosystem Integration",
  },
  {
    id: 2,
    title:
      "Unleash Your Testing Potential: A Path to World-Class Quality with SAQAMA",
    excerpt:
      "In today's competitive landscape, exceptional software quality is the cornerstone of successful digital products...",
    image: testingQualityImage,
    alt: "Software Quality Assurance",
  },
  {
    id: 3,
    title:
      "Rev Up Your Online Sales with the Mix e-tech Commerce Maturity Assessment",
    excerpt:
      "In today's dynamic e-commerce landscape, even minor glitches in your online store can significantly impact conversions...",
    image: ecommerceImage,
    alt: "E-commerce Optimization",
  },
];

const services = [
  {
    id: 1,
    title: "BLOCKCHAIN SERVICES",
    description:
      "Blockchain services offer various, transparent, and decentralized solutions, transforming industries by ensuring data integrity and enabling seamless transactions.",
    icon: blockchainIcon,
  },
  {
    id: 2,
    title: "SALESFORCE DEVELOPMENT",
    description:
      "Selective development enables creating customized OBN solutions, automating processes, and integrating apps to enhance sales, customer service, and business growth.",
    icon: salesforceIcon,
  },
  {
    id: 3,
    title: "AUTOMATION TESTING AND DA",
    description:
      "Automation testing and DA therapies enhance assessment by employing tools to enhance accuracy, efficiency and coverage, ensuring robust, high-quality applications.",
    icon: automationIcon,
  },
  {
    id: 4,
    title: "METAVERSE DEVELOPMENT",
    description:
      "Reference development costs immersive digital media, integrating augmented reality, virtual reality, and blockchain to enhance interactions, entertainment, and commerce.",
    icon: metaverseIcon,
  },
  {
    id: 5,
    title: "AI DEVELOPMENT",
    description:
      "AI development entails crafting advanced platforms that allow audiences to translate human-like cognitive processes, improving effective making, protein-solving, and automotive access characteristics which address requirements efficiently.",
    icon: aiIcon,
  },
  {
    id: 6,
    title: "MOBILITY SOLUTIONS",
    description:
      "Mobile app development involves designing coding and deploying applications for smartphones and tablet, allowing to user needs with efficiency and innovation.",
    icon: mobileIcon,
  },
  {
    id: 7,
    title: "CUSTOMIZED SOFTWARE SOLUTIONS",
    description:
      "Customized EDP solutions optimize business operations by training to enhance specific needs, enhancing efficiency, data management, and productivity across departments.",
    icon: softwareIcon,
  },
  {
    id: 8,
    title: "GAME DEVELOPMENT",
    description:
      "Game development considers creativity and technology to design, code, and produce behaviors and innovates gaining experience across various platforms.",
    icon: gameIcon,
  },

  {
    id: 9,
    title: "CLOUD COMPUTING SERVICES",
    description:
      "Cloud computing provides scalable, on-demand computing resources and services over the internet, enabling businesses to reduce costs and increase flexibility.",
    icon: cloudIcon,
  },
  {
    id: 10,
    title: "CYBERSECURITY SOLUTIONS",
    description:
      "Cybersecurity services protect systems, networks, and data from digital attacks, ensuring business continuity and safeguarding sensitive information.",
    icon: securityIcon,
  },
  {
    id: 11,
    title: "INTERNET OF THINGS (IOT)",
    description:
      "IoT development connects physical devices to the internet, enabling data collection, automation, and remote monitoring across various industries.",
    icon: iotIcon,
  },
  {
    id: 12,
    title: "DEVOPS CONSULTING",
    description:
      "DevOps services bridge development and operations teams to accelerate software delivery while improving reliability and collaboration.",
    icon: devopsIcon,
  },
  {
    id: 13,
    title: "UI/UX DESIGN",
    description:
      "UI/UX design focuses on creating intuitive, engaging user interfaces and experiences that enhance customer satisfaction and drive conversion.",
    icon: designIcon,
  },
  {
    id: 14,
    title: "DATA ANALYTICS",
    description:
      "Data analytics services transform raw data into actionable insights, helping businesses make informed decisions and identify new opportunities.",
    icon: analyticsIcon,
  },
  {
    id: 15,
    title: "DIGITAL MARKETING",
    description:
      "Digital marketing strategies increase online visibility, engage target audiences, and drive growth through various digital channels and platforms.",
    icon: marketingIcon,
  },
  {
    id: 16,
    title: "E-COMMERCE SOLUTIONS",
    description:
      "E-commerce development creates secure, scalable online stores that provide seamless shopping experiences and drive sales conversion.",
    icon: ecommerceIcon,
  },

  {
    id: 17,
    title: "AR/VR DEVELOPMENT",
    description:
      "Augmented and Virtual Reality development creates immersive digital experiences that transform how users interact with products, services, and content.",
    icon: arvrIcon,
  },
  {
    id: 18,
    title: "ROBOTIC PROCESS AUTOMATION",
    description:
      "RPA automates repetitive tasks and business processes using software robots, increasing efficiency and reducing operational costs.",
    icon: rpaIcon,
  },
  {
    id: 19,
    title: "ENTERPRISE SOLUTIONS",
    description:
      "Enterprise solutions integrate business processes across departments, streamlining operations and improving organizational efficiency.",
    icon: enterpriseIcon,
  },

  {
    id: 20,
    title: "OTHER SERVICES",
    description:
      "Complementary and co-marketing drive engagement and growth. Influencer and affiliate marketing enhance industry. Appear Framework Measures into development.",
    icon: otherIcon,
  },
];

const Body = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    budget: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Format the message for WhatsApp
    const message =
      `Hello! I'm interested in your services.%0A%0A` +
      `*Name:* ${formData.name}%0A` +
      `*Email:* ${formData.email}%0A` +
      `*Phone:* ${formData.phone}%0A` +
      `*Project Budget:* ${formData.budget}`;

    // Replace with your actual WhatsApp number (with country code but without + or 0)
    const whatsappNumber = "919155599968";

    // Open WhatsApp with the pre-filled message
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  const facts = [
    { number: "100+", label: "Experienced Developers" },
    { number: "500+", label: "Successful Projects" },
    { number: "9+", label: "Offices" },
    { number: "300+", label: "Clients" },
  ];

  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [images, setImages] = useState([]);

  // Example images (replace with your own URLs)
  const imageUrls = [
    html,
    css,
    js,
    react,
    angular,
    ai,
    vue,
    vscode,
    python,
    gcp,
    googleai,
    azure,
    apacheflink,
    docker,
    kubernative,
    grafna,
    hadoop,
    kotlin,
    kubeflow,
    googletpu,
    openai,
    postsql,
    jupyter,
    anaconda,
    bootstrap,
    mlflow,
    opencv,
    fastai,
    flutter,
    php,
    solidity,
    keras,
    tf,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      const randomImg = imageUrls[Math.floor(Math.random() * imageUrls.length)];
      const newImage = {
        id: Date.now(),
        src: randomImg,
        left: Math.random() * window.innerWidth, // random X position
        size: Math.random() * 40 + 40, // random size 40-80px
        duration: Math.random() * 5 + 5, // random speed 5-10s
      };

      setImages((prev) => [...prev, newImage]);

      // remove old images to avoid memory leak
      setImages((prev) => prev.filter((img) => Date.now() - img.id < 10000));
    }, 300);

    return () => clearInterval(interval);
  }, []);

  const headlines = [
    "Your journey into the next gen starts here",
    "Driving Innovation in IT Solutions",
    "Empowering Businesses with Technology",
    "Building Smarter Digital Futures",
  ];

  const sublines = [
    "Innovating the Future with Creative Technology",
    "Your Trusted Partner in Digital Transformation",
    "Simplifying Complex Tech with Smart Solutions",
    "Delivering Excellence, Every Step of the Way",
  ];

  const [index, setIndex] = useState(0);

  // Change text every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % headlines.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [headlines.length]);

  // Split text into spans for letter-by-letter animation
  const renderText = (text, className) =>
    text.split("").map((char, i) => (
      <span
        key={i}
        className={className}
        style={{ animationDelay: `${i * 0.05}s` }}
      >
        {char === " " ? "\u00A0" : char}
      </span>
    ));

  return (
    <div className="bodymain">
      <div className="image-rain-slider">
        {images.map((img) => (
          <img
            key={img.id}
            src={img.src}
            alt="rain"
            className="falling-image"
            style={{
              left: img.left,
              width: img.size,
              height: img.size,
              animationDuration: `${img.duration}s`,
            }}
          />
        ))}
        <div className="rain-text">
          <h1 key={index + "-h"}>
            {renderText(headlines[index], "char-animate")}
          </h1>
          <p key={index + "-p"}>
            {renderText(sublines[index], "char-animate")}
          </p>
        </div>
      </div>

      <div className="services-container">
        <div className="services-header">
          <div className="header-content">
            <h1>Your Central Hub for All Things AI</h1>
            <h2>Harness Our Full Spectrum of Intelligent Solutions</h2>
          </div>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card-home">
              <div className="service-icon-container">
                <img
                  src={service.icon}
                  alt={service.title}
                  className="service-icon"
                />
                {/* <div className="hexagon"></div>
                <div className="glow"></div> */}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      <section className="industries-section">
        <h2 className="industries-title">Industries We Specialize In</h2>
        <div className="industries-grid">
          {industries.map((industry, index) => (
            <a href={industry.path} className="industry-card" key={index}>
              <div className="industry-icon-container">
                <img
                  src={industry.icon}
                  alt={industry.name}
                  className="industry-icon"
                />
                {/* <div className="hexagon"></div>
                <div className="glow"></div> */}
              </div>
              <span className="industry-name">{industry.name}</span>
            </a>
          ))}
        </div>
      </section>

      <div className="seo-container">
        <div className="seo-content">
          {/* <div className="seo-left">
            <h1 className="seo-title">
              Web Development That's{" "}
              <span className="highlight">Next-Level</span>
            </h1>

            <form onSubmit={handleSubmit} className="seo-form">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  placeholder="Project Budget"
                  required
                />
              </div>
              <button type="submit" className="submit-body-btn">
                Send 
              </button>
            </form>
          </div> */}

          <div className="seo-right">
            <h2 className="results-title">
              Transform Your Digital Presence with Cutting-Edge Web Solutions
            </h2>
            <p className="results-subtitle">
              Delivering High-Performance Websites in 8 Weeks
            </p>

            <div className="stats-container">
              <div className="stat-item">
                <div className="stat-value">98% ↑</div>
                <div className="stat-label-body">Page Speed Improvement</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">100%</div>
                <div className="stat-label-body">Mobile Responsive</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">75% ↑</div>
                <div className="stat-label-body">User Engagement</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="technology-practices">
        <div className="container">
          <h2 className="section-title">{practices[0].category}</h2>

          <div className="practices-grid">
            {practices.map((group, groupIndex) => (
              <React.Fragment key={groupIndex}>
                {group.items.map((practice, index) => (
                  <div key={`${groupIndex}-${index}`} className="practice-card">
                    <div className="card-image-container">
                      <img
                        src={practice.image}
                        alt={practice.name}
                        className="card-image"
                      />
                    </div>
                    <div className="card-content">
                      <h3 className="practice-name">{practice.name}</h3>
                      <p className="practice-description">
                        {practice.description}
                      </p>
                      <button
                        className="view-button"
                        onClick={() => {
                          window.scrollTo(0, 0);
                          window.location.href = practice.link;
                        }}
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      <section className="partnerships-section">
        <div className="container">
          <div className="section-header">
            <h2>Co-innovating with industry leaders</h2>
            <h1>
              Stronger Together: Building Success Through Strategic Partnerships
            </h1>
          </div>

          <div className="partnerships-content">
            <p>
              At Mk e-tech Private Limited, we believe in the power of
              collaboration. By partnering with industry leaders, we can offer
              our clients a comprehensive suite of best-in-class solutions and
              services. Our strategic partnerships empower us to stay at the
              forefront of technology innovation, ensuring we deliver the most
              effective and future-proof solutions to meet your unique business
              needs. Here's a glimpse into our valued technology partnerships:
            </p>

            <div className="partners-grid">
              {partners.map((partner, index) => (
                <div key={index} className="partner-item">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="partner-logo"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="facts-section">
        <div className="container">
          <h2 className="section-title">Fascinating Facts</h2>
          <div className="facts-grid">
            {facts.map((fact, index) => (
              <div key={index} className="fact-card">
                <div className="fact-number">{fact.number}</div>
                <div className="fact-label">{fact.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="blog-cards-container">
        <h1 className="section-title">Latest Insights</h1>
        <div className="blog-cards-grid">
          {blogPosts.map((post) => (
            <div className="blog-card" key={post.id}>
              <div className="card-image-container">
                <img src={post.image} alt={post.alt} className="card-image" />
              </div>
              <div className="card-content">
                <h2 className="card-title">{post.title}</h2>
                <p className="card-excerpt">{post.excerpt}</p>
                <a href="/blog"><button className="read-more-btn">Read More →</button></a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Testimonial />

      <div className="tech-slider-container-body" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
